import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../../Global/OrderColumn/index";
import EmptyData from "../../../Global/EmptyData";
import useCustomerSubscriptions from "../useCustomerSubscriptions";
import SubscriptionDetails from "../SubscriptionDetails";
import CancelSubscription from "../CancelSubscription";
import CreditBalance from "../CreditBalance";
import NotificationSetting from "../NotificationSetting";

const SubscriptionList = () => {
  const {
    isLoading,
    isFetching,
    showEditModal,
    subscriptionList,
    subscriptionState,
    paginationOptions,
    updateSubscriptionFields,
    handleEditColumnsClick,
    handleSettingModal,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    closeAction,
    handleSort,
    refetch,
    getRow,
  } = useCustomerSubscriptions();

  return (
    <div>
      <HeadingGroup
        title={"Customer Subscriptions"}
        className={`pro-mb-4`}
        buttonTitle={"Expiry Warning"}
        handleClick={handleSettingModal}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={subscriptionState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: subscriptionState?.search }}
          handleActionClick={handleEditColumnsClick}
        />

        {subscriptionList?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={subscriptionList?.result || []}
            uniqueID={"subscription_id"}
            fields={subscriptionList?.fields || []}
            SortIcon={<FaSort />}
            handleSort={handleSort}
            getRow={getRow}
            clear={subscriptionState?.clearSelection}
            loading={isFetching}
            perpage={subscriptionState?.currentPageSize}
            assignable={false}
            // Support acts through the row's own buttons rather than the table's edit and
            // delete affordances - a subscription is never deleted, only cancelled.
            editable={false}
            deletable={false}
            showCheckBox={false}
          />
        )}

        {subscriptionList?.result?.length > 0 && (
          <Pagination
            currentPage={subscriptionState?.currentPage}
            totalPageCount={Math.ceil(
              subscriptionList?.total_count / subscriptionState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === subscriptionState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={subscriptionList?.fields || []}
              moduleId={subscriptionList?.module_id}
              updateData={updateSubscriptionFields}
            />
          </div>
        </ModalLayout>

        {/* lg: the ledger table needs more than the default dialog width. */}
        <ModalLayout
          show={subscriptionState?.showDetailsModal}
          handleClose={() => closeAction("showDetailsModal")}
          backdrop="static"
          size="lg"
        >
          <div className="pro-m-5">
            <SubscriptionDetails
              subscriptionId={subscriptionState?.selectedId}
              handleClose={() => closeAction("showDetailsModal")}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={subscriptionState?.showCancelModal}
          handleClose={() => closeAction("showCancelModal")}
          backdrop="static"
        >
          <div className="pro-m-5">
            <CancelSubscription
              subscription={subscriptionState?.selectedSubscription}
              handleClose={() => closeAction("showCancelModal")}
              refetch={refetch}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={subscriptionState?.showCreditModal}
          handleClose={() => closeAction("showCreditModal")}
          backdrop="static"
        >
          <div className="pro-m-5">
            <CreditBalance
              subscription={subscriptionState?.selectedSubscription}
              handleClose={() => closeAction("showCreditModal")}
              refetch={refetch}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={subscriptionState?.showSettingModal}
          handleClose={handleSettingModal}
          backdrop="static"
        >
          <div className="pro-m-5">
            <NotificationSetting handleClose={handleSettingModal} />
          </div>
        </ModalLayout>
      </div>
    </div>
  );
};

export default SubscriptionList;
